/**
 * Classes do `<main>` no layout frontend (`body` em `flex flex-col min-h-screen`).
 * Mesmo padrão inferior que posts e arquivos de taxonomia.
 */
export const SITE_MAIN_SURFACE_CLASS = 'flex-1 w-full min-w-0 pb-8' as const

/**
 * Padding vertical alinhado ao `<article>` do post (`PostArticleShell`).
 * Não envolver o hero `highImpact` (margem negativa sob o header).
 */
export const SITE_MAIN_CONTENT_PADDING_Y_CLASS = 'py-6 md:py-8 lg:py-10' as const

/** Shell da ficha `/moeda/*` — alinhado ao `container` de moedas, posts e páginas CMS. */
export const COIN_PAGE_CONTAINER_CLASS = 'container mx-auto w-full min-w-0' as const

/**
 * Largura máxima global do conteúdo (aba «Layout» do Identidade do site). Substitui os
 * `max-w-[1350px]` hardcoded (header, home, footer). Fallback 1350px quando o override está off
 * (a CSS var `--site-content-width` só é injetada quando ligado) → zero-regressão.
 */
export const SITE_CONTENT_MAXW = 'max-w-[var(--site-content-width,1350px)]' as const

/**
 * Container central do site — FONTE DE VERDADE ÚNICA. Alinhado ao header (`SiteHeader`/
 * `HeaderCategoryRail`) e à Home Editorial (`HOME_BI_CONTAINER` reexporta esta constante).
 * Substitui o utilitário `.container` legado (que divergia em padding-X e max-width por breakpoint:
 * 1rem→2rem no md e largura só travada no 2xl). Aqui: gutters `1rem` mobile → `1.5rem` a partir de
 * `lg`; largura travada em `--site-content-width` (1350px) em todos os breakpoints.
 */
export const SITE_CONTAINER_CLASS =
  `mx-auto w-full ${SITE_CONTENT_MAXW} px-4 lg:px-6` as const

/** Largura de leitura estreita (colunas de texto, headers de taxonomia, estados vazios). */
export const READING_MAXW = 'max-w-3xl' as const

/** Largura de leitura do corpo do artigo (post single). */
export const ARTICLE_MAXW = 'max-w-7xl' as const

/** Arredondamento global das miniaturas/destaque de post (aba «Imagens»). 0 = quadrado (atual). */
export const POST_THUMB_RADIUS = 'rounded-[var(--post-thumb-radius,0px)]' as const

/**
 * Padding horizontal da coluna central (hero, gráfico, secções).
 * NÃO incluir `px-4` no mobile: o wrapper `.container` (COIN_PAGE_CONTAINER_CLASS) já aplica
 * `padding-inline:1rem` no mobile / `1.5rem` no lg. Adicionar px-4 aqui DUPLICAVA o gutter no
 * mobile (16+16=32px). O `md:px-6` só vale a partir de md (espaçamento interno p/ rail/sidebar,
 * que só aparecem em xl/2xl). Abaixo de md o gutter vem só do `.container` (= home/posts).
 */
export const COIN_PAGE_CONTENT_X_CLASS = 'md:px-6' as const
